<template>
  <div>
  <section>
    <div class="left">
      <h2 v-translate>Výběr profilu</h2>
    </div>
  <div class="right">
    <div class="field_left">
      <select-box id="profile"
                  v-model="selectedIdProfile"
                  :options="profileOptions"
                  ref="profileref"
                  :disabled="!$_updateActionAllowed"
                  @input="loadData"
      ><translate class="translate">Profil odběratele</translate>
      </select-box>
  </div>
  </div>
  </section>
    <section>
      <div class="left">
        <h2 v-translate>Nastavení dashboardu</h2>
      </div>
      <div class="right">
  <div class="group_column_box" v-if="idSubscriber">
    <div class="group_column">
      <h2><translate class="translate">Obsah domovské stránky</translate>
        <span v-if="$_updateActionAllowed" class="reset_btn" :title="'Resetovat' | translate" @click.stop.prevent="resetCarousels()">Resetovat</span>
      </h2>
      <ul id="dashboardContent" class="group_column_items ui-sortable">
        <carousel-list-item
            v-for="item in subscriberCarousels"
            :key="item.id"
            :id="item.id"
            :id-subscriber="idSubscriber"
            :name="item.name"
            :is-user-carousel="item.is_user_carousel"
        />
      </ul>
    </div>

    <div class="group_column">
      <h2 v-translate>Dostupné carousely</h2>
      <ul id="availableShowGroups" class="group_column_items ui-sortable">
        <carousel-list-item
            v-for="item in availableCarousels"
            :key="item.id"
            :id="item.id"
            :name="item.name"
            :id-subscriber="idSubscriber"
            :is-user-carousel="item.is_user_carousel"
        />
      </ul>
    </div>
  </div>
      </div>
    </section>
  </div>
</template>

<script>
import CarouselListItem from "./CarouselListItem";
import {arrayEquals} from "@/utils/helpers";
import message from "@/components/mixins/message";

export default {
  name: "CarouselsList",
  mixins: [message],
  components: {CarouselListItem},
  props: {
    idSubscriber: Number
  },
  data() {
    return {
      subscriberCarousels: [],
      availableCarousels: [],
      carouselsOrder: [],
      profileOptions: [],
      selectedIdProfile: null,
    };
  },
  mounted() {
    let selector = $("#dashboardContent, #availableShowGroups");
    $(() => {
      selector.sortable({
        connectWith: ".group_column_items",
        revert: 300,
        scrollSpeed: 30,
        scrollSensitivity: 120,
        tolerance: "pointer",
        disabled: !this.$_updateActionAllowed,
        stop: () => {
          this.onSortingChange();
        }
      });
    });
  },
  created(SubscriberService, SubscriberProfileService) {
    this.SubscriberService = SubscriberService;
    this.subscriberProfileService = SubscriberProfileService;
    this.loadData();
  },
  methods: {
    loadData(){
      this.setLoadingMessage();
      this.subscriberCarousels = [];
      this.availableCarousels = [];
      this.SubscriberService.getSubscriberDashboard(this.idSubscriber, {id_subscriber_profile: this.selectedIdProfile})
          .then((data) => {
            this.subscriberCarousels = data['subscriber_carousels'];
            this.availableCarousels = data['available_carousels'];
            this.carouselsOrder = this.subscriberCarousels.map(item => item.id);
            this.emptyMessage();
            this.subscriberProfileService.getSelectboxList(this.idSubscriber, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(data => {
                  this.profileOptions = data['subscriber_profiles'];
                  let index = this.profileOptions.findIndex((profile)=> {
                    return profile.id === null
                  });
                  this.profileOptions[index].text = this.$gettext("Výchozí profil odběratele");
                });
          });
    },

    onSortingChange() {
      let newCarouselsOrder = ($('#dashboardContent li').map(function () {
        return $(this).attr('id');
      }).get()).map(Number);

      if (!arrayEquals(newCarouselsOrder, this.carouselsOrder)) {
        this.carouselsOrder = newCarouselsOrder;
        this.setSortedCarousels(this.carouselsOrder);
      }
    },

    setSortedCarousels(orderedIds, reloadData = false){
      this.SubscriberService.updateSubscriberDashboard(this.idSubscriber, {carousels_order: orderedIds, id_subscriber_profile: this.selectedIdProfile})
          .then(() => {
            this.setSuccessMessage(this.$gettext("Uloženo"), 750);
            if(reloadData){
              this.loadData();
            }
          }).catch((error)=> {
        this.setErrorMessage(error);
        this.loadData();
      });
    },

    resetCarousels(){
      this.setSortedCarousels([], true)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/dashboard/CarouselsList.vue